<div class="bg-top-center space-top overflow-hidden" data-bg-src="assets/img/bg/contact_bg_2.jpg">
    <div class="container">
        <div class="row">
            <div class="col-xl-5 col-xxl-6">
                <div class="pe-xxl-4 me-xxl-4">
                    <div class="title-area">
                        <span class="sub-title text-white text-anime-style-2">Get in touch</span>
                        <h2 class="sec-title text-white text-anime-style-3">Do You Need Help For Your Next Projects ?
                        </h2>
                        <p class="text-white wow fadeInLeft" data-wow-delay=".2s">A Startup Tech Agency specializes in
                            providing innovative, scalable, and customized technology solutions to help startups build,
                            grow, and succeed in a competitive market. By combining technical expertise with an
                            understanding.</p>
                    </div>
                    <div class="contact-form-area2 wow fadeInUp" data-wow-delay=".3s">
                        <form action="mail.php" method="POST" class="contact-form2 ajax-contact">
                            <div class="row">
                                <div class="form-group col-12">
                                    <input type="text" class="form-control" name="name" id="name3"
                                        placeholder="First Name">
                                    <img src="assets/img/icon/user.svg" alt="">
                                </div>
                                <div class="form-group col-12">
                                    <input type="email" class="form-control" name="email3" id="email3"
                                        placeholder="Your Mail">
                                    <img src="assets/img/icon/mail.svg" alt="">
                                </div>
                                <div class="form-group col-12">
                                    <select name="subject" id="subject" class="form-select nice-select">
                                        <option value="Select Subject" selected disabled>Select Subject</option>
                                        <option value="Africa Adventure">App Development</option>
                                        <option value="Africa Wild">App Design</option>
                                        <option value="Asia">WordPress Theme</option>
                                        <option value="Scandinavia">Python Development</option>
                                        <option value="Western Europe">Django Templete</option>
                                    </select>
                                </div>
                                <div class="form-group col-12">
                                    <textarea name="message" id="message" cols="30" rows="3" class="form-control"
                                        placeholder="Your Message"></textarea>
                                    <img src="assets/img/icon/chat.svg" alt="">
                                </div>
                            </div>
                            <p class="form-messages mb-0 mt-3"></p>
                        </form>
                        <div class="form-btn-wrapp form-btn-wrapp2">
                            <div class="form-btn">
                                <button class="th-btn white-btn">Send Message <img src="assets/img/icon/plane3.svg"
                                        alt=""></button>
                            </div>
                            <div class="contact-info">
                                <p class="contact-info_link"><a href="tel:+0123456789">+012 345 6789</a></p>
                                <div class="contact-info_icon">
                                    <a href="tel:+0123456789"><img src="assets/img/icon/call.svg" alt=""></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-7 col-xxl-6">
                <div class="counter-wrap2">
                    <div class="row gy-50">

                        <div class="col-md-6 col-xl-6 counter-card_wrapp">
                            <div class="counter-card style2">
                                <div class="counter-shape"><span></span></div>
                                <div class="media-body">
                                    <h3 class="box-number text-white">
                                        <span class="counter-number">97</span>%
                                    </h3>
                                    <h6 class="counter-title text-white">Retention Rate</h6>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-xl-6 counter-card_wrapp">
                            <div class="counter-card style2">
                                <div class="counter-shape"><span></span></div>
                                <div class="media-body">
                                    <h3 class="box-number text-white">
                                        <span class="counter-number">19</span>k
                                    </h3>
                                    <h6 class="counter-title text-white">Happy Clients</h6>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-xl-6 counter-card_wrapp">
                            <div class="counter-card style2">
                                <div class="counter-shape"><span></span></div>
                                <div class="media-body">
                                    <h3 class="box-number text-white">
                                        <span class="counter-number">12</span>
                                    </h3>
                                    <h6 class="counter-title text-white">Years Experience</h6>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-xl-6 counter-card_wrapp">
                            <div class="counter-card style2">
                                <div class="counter-shape"><span></span></div>
                                <div class="media-body">
                                    <h3 class="box-number text-white">
                                        <span class="counter-number">8</span>k
                                    </h3>
                                    <h6 class="counter-title text-white">Project Completed</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>